var lib_core = require("lib-core");
var cio_config = require("cio-config");
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");

if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");
    
var HeaderRightAngleGeneratorInteractionModel = require('./headerRightAngleGeneratorInteractionModel.js');

var HeaderRightAngleSocketGeneratorInteractionModel = function(IpcPthPadGeneratorData, userSettingsModel, showFootprintParams) {
    HeaderRightAngleGeneratorInteractionModel.apply(this, arguments);
};

lib_core.inherit(HeaderRightAngleSocketGeneratorInteractionModel, HeaderRightAngleGeneratorInteractionModel);
HeaderRightAngleSocketGeneratorInteractionModel.$class = 'HeaderRightAngleSocketGeneratorInteractionModel';
module.exports = HeaderRightAngleSocketGeneratorInteractionModel;

HeaderRightAngleSocketGeneratorInteractionModel.prototype.getInspectorElementForTerminalLength = function() {
    var tailLength1 = PackageGeneratorInspectorConfig.getMinMaxRow('L1', this.LCLZ('hTerminalTailLength', 'Horizontal Terminal Tail Length'), true, null, false, this.horizontalTerminalTailLength, this.userSettingsModel.distanceUnit);
    var tailLength2 = PackageGeneratorInspectorConfig.getMinMaxRow('L2', this.LCLZ('vTerminalTailLength', 'Vertical Terminal Tail Length'), true, null, false, this.verticalTerminalTailLength, this.userSettingsModel.distanceUnit);

    return [tailLength1, tailLength2];
};
